import { FormattedMessage } from "react-intl";
import messages from "./messages";

export const statusResponseError = (value: number | string): JSX.Element => {
  if (value === 401) return <FormattedMessage {...messages.unauthorized} />;
  if (value >= 500)
    return <FormattedMessage {...messages.serviceUnavailable} />;
  return <FormattedMessage {...messages.unknown} />;
};
